//自定义表单表头： 国际化翻译中英对应关系表
export default {
    "数据标题": 'Data Title',
    "创建人": 'Creator',
    "创建时间": 'Creation Time',
    "单据号": 'Sequence No.',
    "业务对象": 'Business Object',
    "业务对象ID": 'Business Object ID',
    "创建人部门": 'Dept. Of Creater',
    "拥有者": 'Owner',
    "拥有者部门": 'Dept. Of Owner',
    "修改人": 'Modifier',
    "修改时间": 'Modification Time',
    "单据状态": 'Sequece Status',
    "新增": 'New',
    "删除": 'Del.',
    "导入": 'Import',
    "导出": 'Export',
    "批量修改": 'Batch Edit',
    "批量删除": 'Batch Del.',
    "修改拥有者": 'Modify Owner',
    "批量打印": 'Batch Printing',
    "打印二维码": 'Print QR Code',
};
